import { getGtmClient } from "./get-gtm-client";

export type GeoLocation = {
  country?: string;
  country_code?: string;
  region?: string;
  marketing_consent_required?: boolean;
};

const GEO_LOCATION_CACHE_KEY = "geo_location";

const clearCache = () => {
  try {
    window.localStorage?.removeItem(GEO_LOCATION_CACHE_KEY);
    window.sessionStorage?.removeItem(GEO_LOCATION_CACHE_KEY);
  } catch {
    return false;
  }
  return true;
};

/**
 * gtm-js caches the geo_location payload with no expiry, so a payload predating
 * marketing_consent_required would otherwise be served to returning visitors forever.
 * Drop the cache once and refetch when the consent answer is missing.
 */
export async function getGeoLocation(): Promise<GeoLocation> {
  const gtmClient = await getGtmClient();
  const cached: GeoLocation = await gtmClient.getGeoLocation();

  if (cached?.marketing_consent_required !== undefined) return cached;
  if (!clearCache()) return cached;

  return gtmClient.getGeoLocation();
}
